module.exports = __webpack_public_path__ + "img/woman.55399338.png";